import { useSearchParams } from 'react-router';
import { Heading } from '@astryxdesign/core/Heading';
import { VStack } from '@astryxdesign/core/Stack';
import { useBookingNav, useStudio } from '../app/studio';
import { AssistantChat } from '../assistant/AssistantChat';
import { localDayOf } from '../lib/time';

export function AssistantPage() {
  const studio = useStudio();
  const booking = useBookingNav();
  const [params] = useSearchParams();
  return (
    <main className="app-page app-page--top">
      <VStack gap={3} paddingInline={4} minHeight="calc(100dvh - 120px)">
        <Heading level={1}>Помощник</Heading>
        <AssistantChat
          slug={studio.slug}
          scope="client"
          examples={studio.assistant_examples.length ? studio.assistant_examples : ['Когда ближайшее окно?', 'Как найти студию?']}
          initialQuestion={params.get('q')}
          intro={`Помощник ${studio.short_name} отвечает по услугам, ценам и свободному времени. Записи других клиентов он не видит.`}
          onPickSlot={(s) => booking.go('contacts', { service: s.service_id, at: s.starts_at, day: localDayOf(s.starts_at, studio.timezone) })}
          onFallback={() => booking.open()}
        />
      </VStack>
    </main>
  );
}
